import React, {Component} from "react";
import {connect} from "react-redux";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import {FJMediaAction, FJToolbarAction} from "../../../redux/action/FJRoot.action";
// import FJEvent from "../../../core/FJEvent";
import FJEventConstant from "../../../constant/FJEventConstant";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJToolbarTextContainer from './FJToolbarTextContainer';
import FJToolbarPhotoContainer from './FJToolbarPhotoContainer';
import FJToolbarVideoContainer from './FJToolbarVideoContainer';
import FJToolbarAudioContainer from './FJToolbarAudioContainer';
import FJToolbarBackgroundColorContainer from "./FJToolbarBackgroundColorContainer";
import FJToolbarWidgetContainer from "./FJToolbarWidgetContainer";
import FJToolbarStaticSvgContainer from "./FJToolbarStaticSvgContainer";
import FJToolbarOverLayContainer from "./FJToolbarOverLayContainer";
import FJToolbarOverLayTextContainer from "./FJToolbarOverLayTextContainer";
import FJToolbarOverLayImageContainer from "./FJToolbarOverLayImageContainer";
import FJToolbarCropContainer from "./FJToolbarCropContainer";

/**
 * @class FJToolbarContainer
 * @description 工具操作栏容器
 */
class FJToolbarContainer extends Component {

  componentDidMount() {
    let {updateToolbar} = this.props;
    window.FJEvent.subscribe('updateToolbar', updateToolbar);
    window.FJEvent.subscribe(FJEventConstant.GRAPH_INIT, updateToolbar)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedType !== this.props.selectedType) {
      FJCoreUtil.triggerBodyMousedown();
    }
  }

  render() {
    let {selectedType, cropMode} = this.props;
    let {onLinkAction, onRetryAction} = this.props;
    let {VIDEO, IMAGE, AUDIO, TEXT_ANIMATION, BACKGROUND, WIDGET, MULTI_WIDGET, SVG, OVERLAY, DECORATION_OVERLAY, DYNAMIC_LOGO, SHAPE, TEXT, STATIC_IMAGE} = FJCoreConstant;
    return (
      <>
        <FJToolbarTextContainer active={selectedType === TEXT_ANIMATION} />
        <FJToolbarPhotoContainer active={selectedType === IMAGE && !cropMode} onLinkFun={onLinkAction} onRetryFun={onRetryAction}/>
        <FJToolbarVideoContainer active={selectedType === VIDEO && !cropMode} onLinkFun={onLinkAction} onRetryFun={onRetryAction}/>
        <FJToolbarAudioContainer active={selectedType === AUDIO} onLinkFun={onLinkAction} onRetryFun={onRetryAction}/>
        <FJToolbarBackgroundColorContainer active={selectedType === BACKGROUND} />
        <FJToolbarWidgetContainer hasOpacity={selectedType === WIDGET} hasFlip={selectedType === WIDGET} active={(selectedType === DECORATION_OVERLAY || selectedType === WIDGET || selectedType === MULTI_WIDGET)} />
        <FJToolbarStaticSvgContainer active={selectedType === SVG} />
        <FJToolbarOverLayContainer active={(selectedType === OVERLAY || selectedType === DYNAMIC_LOGO || selectedType === SHAPE)}/>
        <FJToolbarOverLayTextContainer active={selectedType === TEXT}/>
        <FJToolbarOverLayImageContainer active={selectedType === STATIC_IMAGE && !cropMode}/>
        <FJToolbarCropContainer active={(selectedType === IMAGE || selectedType === VIDEO || selectedType === STATIC_IMAGE) && cropMode}/>
      </>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    selectedType: state.toolbar.selectedType,
    cropMode: state.toolbar.cropMode,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    updateToolbar: function () {
      dispatch(FJToolbarAction.updateToolbarAction())
    },
		onLinkAction: function () {
    	dispatch(FJMediaAction.openLinkModalByUser());
		},
		onRetryAction: function () {
    	dispatch(FJMediaAction.retryMediaAction())
		}
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarContainer);
